import {H6Text, PSmallText} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {B2BScreens} from '@buncha/B2B/navigation/types';
import {Box} from '@buncha/components/core/view';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface BarcodeUserInfoProps {
  userFullName: string;
}

const BarcodeUserInfo: React.FC<BarcodeUserInfoProps> = props => {
  const {userFullName} = props;
  const muliFont = useFontTheme('muli');
  const {body} = useGetLocale(Modules.B2B, B2BScreens.B2BBarcode) ?? {};
  const theme = useColorThemeType();
  return (
    <Box style={styles.container}>
      <PSmallText
        style={{
          fontFamily: muliFont[600].normal,
          color: theme?.text.blue[300],
        }}>
        {body?.customerName}
      </PSmallText>
      <H6Text
        style={{
          fontFamily: muliFont[700].normal,
          color: theme?.text.blue[300],
        }}>
        {userFullName}
      </H6Text>
    </Box>
  );
};

export default React.memo(BarcodeUserInfo);
